import { queryOptions } from '@tanstack/react-query'
import type { Database } from '@/types/supabase'
import { supabase } from '@/lib/supabase/client'

export type BillingAccount =
  Database['public']['Tables']['billing_accounts']['Row']

export const billingAccount = {
  findOne: (billingAccountId: string) =>
    queryOptions({
      queryKey: ['billing-account', billingAccountId],
      queryFn: async () => {
        if (!billingAccountId || billingAccountId.trim() === '') {
          throw new Error(
            'Invalid billingAccountId: cannot fetch billing account without valid billing account ID'
          )
        }

        const { data, error } = await supabase
          .from('billing_accounts')
          .select('*')
          .eq('id', billingAccountId)
          .single()

        if (error) {
          throw new Error(`Failed to fetch billing account: ${error.message}`, {
            cause: error,
          })
        }

        if (!data) {
          throw new Error('Billing account not found')
        }

        return data
      },
    }),
}
